'use client'

import { getApolloClient } from '@/lib/apollo-client'
import { ApolloProvider as AppoloClientProvider } from '@apollo/client'
import React, { useMemo } from 'react'

export default function ApolloProvider({ children }: { children: React.ReactNode }) {
  const client = useMemo(() => {
    const apolloClient = getApolloClient()

    return apolloClient
  }, [])

  return <AppoloClientProvider client={client}>{children}</AppoloClientProvider>
}
